<template>
  <div class="main" v-loading="loading">
    <div class="btns">
      <el-select
        v-model="chaVal"
        @change="switchFn"
        placeholder="请选择查询方式"
        style="width: 200px; margin: 0 6px"
      >
        <el-option label="账号" value="1"></el-option>
        <el-option label="公司" value="2"></el-option>
      </el-select>
      <el-input
        v-if="chaVal == '1'"
        v-model="username"
        placeholder="请填写账号"
        maxlength="11"
        oninput="value=value.replace(/[^\d]/g,'')"
        class="input"
      ></el-input>
      <el-input
        v-if="chaVal == '2'"
        v-model="name"
        placeholder="请填写公司名称"
        class="input"
      ></el-input>
      <el-row>
        <el-button type="primary" @click="search" style="margin-left: 12px"
          >查询</el-button
        >
      </el-row>
    </div>


    <el-table :data="user_list" style="width: 100%">
      <el-table-column prop="username" label="帐号"></el-table-column>
      <el-table-column label="零工账号类型">
        <template slot-scope="scope">
          <el-tag :type="scope.row.odd_job_status == 0 ? '' : ( scope.row.odd_job_status == 1 ? 'success' : ( scope.row.odd_job_status == 2 ? 'warning' : 'info' ) ) ">
            {{ scope.row.odd_job_status == 0 ? '餐饮兼职' : ( scope.row.odd_job_status == 1 ? '家政服务' : ( scope.row.odd_job_status == 2 ? '学习辅导' : scope.row.odd_job_status ) ) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="公司名称/姓名"></el-table-column>
      <el-table-column prop="agent_name" label="归属代理商"></el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column prop="is_expire" label="是否关闭">
        <template slot-scope="scope">{{
          scope.row.is_expire ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button type="warning" @click="bianji(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    
     <div class="pagination">
        <el-pagination
          background
          @current-change="Turn"
          layout="prev, pager, next"
          :current-page="ispage"
          :total="user_count"
          :page-size="15"
        >
        </el-pagination>
      </div>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="
        () => {
          dialogVisible = false;
        }
      "
    >
      <el-form ref="form" class="form" :model="data_obj" label-width="100px">
        <el-form-item label="账号">
          <el-input
            maxlength="11"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="data_obj.username"
          ></el-input>
        </el-form-item>

        <el-form-item label="是否关闭">
          <el-select
            v-model="data_obj.is_expire"
            placeholder="请选择该账号是否关闭"
          >
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="data_obj.name"></el-input>
        </el-form-item>
        <el-form-item label="归属代理商">
          <el-cascader
            placeholder="请选择归属代理商"
            v-model="data_obj.agent_id"
            :options="agent_list"
            @change="agent_change"
          ></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="bianjiYes">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
import axios from "axios";
// import { delete } from 'vue/types/umd';

export default {
  data() {
    return {
      loading: false,
      agent_list: [], //代理商列表
      username: "", //账号
      name: "", //公司名称
      tr_id: "", //权限id
      chaVal: "1", //筛选1账号，2公司
      page: 0, //页码
      user_count: 0, //总数量
      user_list: [], //总列表
      data_obj: {}, //点击编辑时保存的数据
      dialogVisible: false,
    };
  },
  computed:{
    ispage:function(){
      return this.page + 1;
    }
  },
  created() {
    this.client_list();
    this.show_agent_city();
  },
  methods: {
    // 代理商列表
    show_agent_city() {
      require("post", "/hr24_user/v1/show_agent_city/", {}).then((res) => {
        if (res.code == 0) {
          //   console.log(res.data);
          this.agent_list = res.data;
        }
      });
    },

     // 翻页
    Turn(val) {
      this.page = val - 1;
      this.client_list();
    },
    // 客户管理列表
    client_list() {
      this.loading = true;
      require("post", "/hrswork/v1/client_list/", {
        username: this.username,
        name: this.name,
        tr_id: this.tr_id,
        page:this.page,
      }).then((res) => {
        if (!res.code) {
          this.user_count = res.data.user_count;
          this.user_list = res.data.user_list;
          this.loading = false;
        }
      });
    },
    // 筛选切换
    switchFn() {
      this.username = "";
      this.name = "";
    },
    // 查询
    search() {
      this.page = 0;
      
      console.log(this.page)
      this.client_list();
    },
    // 编辑
    bianji(item) {
      this.data_obj = JSON.parse(JSON.stringify(item));
      console.log(this.data_obj);
      this.dialogVisible = true;
    },
    // 选择归属代理商
    agent_change(val) {
      console.log(val);
    },
    // 确认编辑
    bianjiYes() {
      var obj = {
        username: this.data_obj.username,
        update_data: {
          username: this.data_obj.username,
          is_expire: this.data_obj.is_expire,
          name: this.data_obj.name,
          agent_id:
            typeof this.data_obj.agent_id == "string"
              ? this.data_obj.agent_id
              : this.data_obj.agent_id[this.data_obj.agent_id.length - 1],
        },
      };
      require("post", "/hrswork/v1/update_client/", obj).then((res) => {
        if (!res.code) {
          this.$message.success(res.msg);
          this.dialogVisible = false;
          this.client_list();
          this.data_obj = {};
        }
      });
    },
  },
};
</script>

<style scoped>
.main {
  min-height: 80vh;
}

.show,
.show_s {
  width: 100%;
}
.show > div {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 33px;
}
.show div > div:first-child {
  color: #303030;
}
.show div > div:last-child {
  color: #606060;
}

.btns {
  display: flex;
  margin-bottom: 20px;
}

.input {
  width: 20%;
}
/* .show_s .el-input {
  width: 40%;
} */
.without {
  font-size: 14px;
  color: #303030;
}
.quYes {
  padding: 12px 0;
  text-align: center;
}
/* .quYes > button {
  float: right;
  margin: 0 5px;
} */

.form /deep/ .el-input__inner {
  width: 350px;
}
.pagination {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/lielingyun/hrs_customer.vue